import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { observable } from 'mobx';
import TinyInputStore from '@src/components/tiny-input/store';
import { noop } from '@src/utils/common-util';
import { isString, isUndefined } from '@src/utils/type-utils';
import * as commonRegex from '@src/utils/common-regex';
import { useRequest } from 'ahooks';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';

class ReceiveAwardModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  // 是否可以填写
  @observable editable = true;

  // 是否出现二次弹窗
  @observable isCheckModal = false;

  // 是否为已经填写过
  @observable isFinished = false;

  // 提示文案
  @observable warnTip = '* 请按照省/市/区（县）/xx号的格式填写真实有效的收货信息，<span>仅有一次填写机会</span>';

  // 姓名
  nameInput = new TinyInputStore();

  // 手机号码
  phoneInput = new TinyInputStore({
    onChange: value => {
      if (isString(value)) {
        this.phoneInput.value = value;
        return false;
      }
      let val = value?.target?.value;
      if (!isUndefined(val)) {
        val = val.replace(/[^A-Za-z0-9\u4e00-\u9fa5 ]/g, '');
        val = val.slice(0, 11);
      }
      this.phoneInput.value = val;
    }
  });

  // 地址
  addressInput = new TinyInputStore();

  // 点击确定
  @observable onConfirmClick = noop;

  /**
   * 点击"确定"
   */
  onConfirmBtnClick = () => {
    if (this.editable) {
      if (!this.nameInput.value) {
        $$tracker.clickSubmit('fail', '姓名不能为空');
        AntdMessage.info('姓名不能为空');
      } else if (!this.phoneInput.value) {
        $$tracker.clickSubmit('fail', '请填入正确的手机号');
        AntdMessage.info('请填入正确的手机号');
      } else if (!commonRegex.phoneNumber.test(this.phoneInput.value) || this.phoneInput.value.length !== 11) {
        $$tracker.clickSubmit('fail', '手机号格式不正确');
        AntdMessage.info('请填入正确的手机号');
      } else if (!this.addressInput.value) {
        $$tracker.clickSubmit('fail', '地址不能为空');
        AntdMessage.info('地址不能为空');
      } else {
        if (this.isCheckModal) {
          $$tracker.clickSubmit('success', '');
          this.onCheckConfirmClick();
        } else {
          this.warnTip = '*确认后不支持修改，请仔细核对收货信息';
          this.isCheckModal = true;
        }
      }
    } else {
      this.onClickClose();
    }
  };

  //返回修改
  onClickCancelSubmit = () => {
    this.warnTip = '* 请按照省/市/区（县）/xx号的格式填写真实有效的收货信息，<span>仅有一次填写机会</span>';
    this.isCheckModal = false;
  };

  /**
   * 点击二次确认弹窗的确认
   */
  onCheckConfirmClick = () => {
    this.setAddressMsg.run();
  };

  // 设置中奖接受地址
  setAddressMsgAsync = () => {
    return this.$ztService.setAddress(this.nameInput.value, this.phoneInput.value, this.addressInput.value);
  };

  use() {
    super.use();
    this.setAddressMsg = useRequest(async () => await this.setAddressMsgAsync(), {
      manual: true,
      onSuccess: data => {
        $$tracker.clickConfirm('success', '');
        AntdMessage.success('设置收货地址成功!');
        this.isFinished = true;
      },
      onError: e => {
        const errorMessage = e.serviceResponse?.message || e.message;
        $$tracker.clickConfirm('fail', errorMessage);
        AntdMessage.error(e.serviceResponse?.message);
        this.onClickCancelSubmit();
      }
    });
    useMount(() => {});
  }
}

export default ReceiveAwardModalStore;
